// extracted by mini-css-extract-plugin
export default {"root":"WaterMark_root__lnK3O","wrapper":"WaterMark_wrapper__-gWVm"};